import { DocumentStatus } from "../../../graphql/supergraphEnums";
import { type RequestedDocumentType } from "../../../graphql/supergraphTypes";
import { DocumentFormProps } from "../DocumentCollector/types";
import { getDocumentCategoryInfo } from "../DocumentCollector/utils";

export const mapGuestDocumentsToFormProps = (
  documentTypes: Array<RequestedDocumentType>,
): DocumentFormProps[] => {
  return (
    documentTypes
      // Filter out documents that are marked as uploaded but don't exist in the documents array
      .filter((docType) => {
        return docType.status !== DocumentStatus.Uploaded;
      })
      .map((docType) => {
        const documentCategory = getDocumentCategoryInfo(docType.baseType, docType.subType);

        return {
          id: undefined,
          baseType: docType.baseType,
          subType: docType.subType || null,
          file: null,
          title: documentCategory.title,
          description: documentCategory.description,
        };
      })
  );
};
